import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrivateModeProtectionCircleIcon = function PrivateModeProtectionCircleIcon(_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#6B7280' : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 34 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 34 32"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2",
      clipPath: "url(#clip0_2556_29332)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.38 14.476H9.144M12.484 23.238a2.476 2.476 0 100-4.952 2.476 2.476 0 000 4.952zM20.919 23.238a2.476 2.476 0 100-4.952 2.476 2.476 0 000 4.952zM18.442 20.42H14.96M22.095 14.476l-.888-5.33a1.828 1.828 0 00-1.805-1.527H14.12M14.12 7.619a1.828 1.828 0 00-1.803 1.528M12.317 9.146l-.888 5.33"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.762 30.476c7.995 0 14.476-6.481 14.476-14.476 0-7.995-6.481-14.476-14.476-14.476C8.767 1.524 2.286 8.005 2.286 16c0 7.995 6.481 14.476 14.476 14.476z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2556_29332",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H33.524V32H0z"
        })
      })
    })]
  }));
};
export default PrivateModeProtectionCircleIcon;